import { useCallback, useState } from 'react'
import { CodeNext } from '@fusion-advantage/backcompat'
import { V2L3CancelEncounterModal } from '@fusion-advantage/formrender'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { CancelReason, serializeFusionError } from '@fusion-advantage/backcompat'
import { WorkItemType } from '@fusion-advantage/formlib'
import { AppModal, dismissAppModal } from '../../../redux/appSlice'
import { updateEncounterStatus } from '../../../dal2/updateEncounterStatus'
import { appError } from '../../../redux/errorSlice'
import { appSync } from '../../../redux/syncthunk/syncThunk'
import { SyncType } from '../../../redux/syncthunk/SyncConfig'
import { selectSelectedStatusedWorkItem } from '../../../redux/selectSelectedWorkItem'

export const LxCancelEncounterModal = () => {
	const selectedStatusedItem = useAppSelector(selectSelectedStatusedWorkItem)
	const displayExp = useAppSelector(state => state.dashboardMwResult.displayExp)
	const reasons = useAppSelector(state => state.dashboardMwResult.cancelReasons)
	const dispatch = useAppDispatch()
	const [selectedReason, setSelectedReason] = useState<CancelReason|null>(null)
	const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
		if(!e.target.value) {
			setSelectedReason(null)
		}
		const reason = reasons.find(reason => reason.CancelReasonName === e.target.value)
		if(!reason) {
			dispatch(appError({
				err: serializeFusionError('LxCancelEncounterModal', 'expected reason but null'),
			}))
			setSelectedReason(null)
			return
		}
		setSelectedReason(reason)
	}, [reasons])
	const handleSubmit = useCallback(async () => {
		if(!displayExp) {
			dispatch(appError({
				err: serializeFusionError('LxCancelEncounterModal', `expected export for action but null`)
			}))
			return
		}
		if(!selectedReason) {
			alert('Please choose a reason for cancellation.')
			return
		}
		const r = await dispatch(updateEncounterStatus(displayExp.encounterGuid, CodeNext.Cancelled, selectedReason))
		if(r.isErr()) {
			dispatch(appError({
				err: serializeFusionError('LxCancelEncounterModal', r.error),
			}))
		}
		dispatch(appSync({
			// dan says he doesn't care if this goes back to the server right
			// away, so we can suppress errors if the user is offline
			type: SyncType.DashboardDeferrable,
		}))
		dispatch(dismissAppModal(AppModal.CancelEncounter))
	}, [displayExp, selectedReason, dispatch])
	return (
		<V2L3CancelEncounterModal
			encounterType={selectedStatusedItem?.type === WorkItemType.Appointment ? 'Appointment' : 'Encounter'}
			reasons={reasons.map(reason => reason.CancelReasonName)}
			selectedReason={selectedReason?.CancelReasonName}
			onDismissClick={() => dispatch(dismissAppModal(AppModal.CancelEncounter))}
			onChange={handleChange}
			onSubmitClick={handleSubmit}
		/>
	)
}
